'use strict';
import React from 'react';
import classnames from 'classnames';
import FormField from 'forms/formField';


export default class TextField extends React.Component {

    constructor(props) {

        super(props);
        this.state = {
            focussed: false
        };
    }


    static propTypes = {
        field: React.PropTypes.object.isRequired
    };

    shouldComponentUpdate(nextProps) {
        return this.props.field !== nextProps.field;
    }


    onBlur(e) {

        this.setState({focussed: false});
        if (this.props.field.onBlur) {
            this.props.field.onBlur(e);
        }
    }


    onFocus(e) {

        this.setState({focussed: true});
        if (this.props.field.onFocus) {
            this.props.field.onFocus(e);
        }
    }


    onChange(e) {
        this.props.field.onChange(e);
    }

    render() {
        var {field, help, label, onChange, showErrorMessage, textarea, ...inputProps} = this.props;
        var error = field.touched && field.error;
        let cssClass = classnames(
            'item__input',
            {'item__input--text': !textarea},
            {'item__input--textarea': textarea},
            {'item__input--error': error},
            {'item__input--focus': this.state.focussed}
        );

        return (
            <FormField field={field} help={help} inputProps={inputProps}>
                <div className={cssClass}>
                    <label htmlFor={field.name}>{field.placeholder}:</label>
                    {textarea ?
                    <textarea
                        {...inputProps}
                        name={field.name}
                        id={field.name}
                        value={field.value}
                        onBlur={::this.onBlur}
                        onFocus={::this.onFocus}
                        onChange={::this.onChange}
                        />
                    :
                    <input
                        {...inputProps}
                        className="input__text"
                        name={field.name}
                        id={field.name}
                        value={field.value}
                        onBlur={::this.onBlur}
                        onFocus={::this.onFocus}
                        onChange={::this.onChange}
                        autoComplete="off"
                        type="text"
                    />}
                    { error && <div className="input__error">{error}</div>}
                </div>
            </FormField>
        );
    }
}



// WEBPACK FOOTER //
// ./static/app/forms/textField.jsx